var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.56283 12.0625L6.54199 9.04168C6.50033 9.00001 6.46908 8.95487 6.44824 8.90626C6.42741 8.85765 6.41699 8.80557 6.41699 8.75001C6.41699 8.6389 6.45519 8.54168 6.53158 8.45834C6.60796 8.37501 6.70866 8.33334 6.83366 8.33334H13.167C13.292 8.33334 13.3927 8.37501 13.4691 8.45834C13.5455 8.54168 13.5837 8.6389 13.5837 8.75001C13.5837 8.77779 13.542 8.87501 13.4587 9.04168L10.4378 12.0625C10.3684 12.132 10.2989 12.1806 10.2295 12.2083C10.16 12.2361 10.0837 12.25 10.0003 12.25C9.91699 12.25 9.8406 12.2361 9.77116 12.2083C9.70171 12.1806 9.63227 12.132 9.56283 12.0625Z",
    fill: "#252153"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDropDown);
export default __webpack_public_path__ + "static/media/arrow_drop_down.274a2e5c1aca7595759a72c64c38e082.svg";
export { ForwardRef as ReactComponent };